import * as alt from './alt.js';
export * from 'fp-ts/Alternative';
export function altAllBy(F) {
    return alt.altAllBy(F)(F.zero());
}
//# sourceMappingURL=alternative.js.map